














































import { Component, Ref, Vue, Emit, Prop, Watch } from "vue-property-decorator";
import { noop } from "lodash";
import SignaturePad from "signature_pad";
import mergeImages from "merge-images";

import FileDrop from "@/components/common/FileDrop.vue";
import { fileToBase64, resizeImage } from "@/utils/image";

const DEFAULT_OPTIONS = {
  dotSize: (0.5 + 2.5) / 2,
  minWidth: 0.5,
  maxWidth: 2.5,
  throttle: 16,
  minDistance: 5,
  backgroundColor: "white",
  penColor: "black",
  velocityFilterWeight: 0.7,
  onBegin: noop,
  onEnd: noop
};

@Component({
  components: {
    FileDrop
  }
})
export default class MySignaturePad extends Vue {
  @Ref() signaturePadCanvas!: HTMLCanvasElement;
  @Ref() currentSignature?: string = "";

  @Prop({ required: true })
  isSubmitting!: boolean;

  @Prop()
  signOnly!: boolean;

  @Prop()
  signatureString!: string;

  signaturePad!: SignaturePad;
  onResizeHandler!: EventListenerOrEventListenerObject;

  @Watch("signatureString")
  onSignatureStringChange() {
    this.populateImage(this.signatureString);
  }

  mounted() {
    const canvas = this.signaturePadCanvas;
    this.signaturePad = new SignaturePad(canvas, DEFAULT_OPTIONS);
    // Add event listener
    this.onResizeHandler = this.resizeCanvas.bind(this);
    window.addEventListener("resize", this.onResizeHandler, false);
    this.resizeCanvas();
    this.populateImage(this.signatureString);
    this.signaturePad.addEventListener("endStroke", this.saveSignature, false);
  }

  beforeDestroy() {
    // Remove event listener
    if (this.onResizeHandler) {
      window.removeEventListener("resize", this.onResizeHandler, false);
    }
    this.signaturePad.removeEventListener("endStroke", this.saveSignature, false);
  }

  get ratio() {
    return Math.max(window.devicePixelRatio || 1, 1);
  }

  get canvasWidth() {
    return this.signaturePadCanvas.offsetWidth * this.ratio;
  }

  get canvasHeight() {
    return this.signaturePadCanvas.offsetHeight * this.ratio;
  }

  saveSignature() {
    this.currentSignature = this.signaturePad.toDataURL();
  }

  resizeCanvas() {
    const canvas = this.signaturePadCanvas;
    const data = this.signaturePad.toDataURL();

    // Handle different DPI screens
    canvas.width = this.canvasWidth;
    canvas.height = this.canvasHeight;
    canvas.getContext("2d")?.scale(this.ratio, this.ratio);

    this.signaturePad.clear();
    this.signaturePad.fromDataURL(data);
  }

  clearCanvas() {
    this.signaturePad.clear();
    this.currentSignature = "";
  }

  async populateImage(base64String: string) {
    const resizedString = (await resizeImage(
      base64String,
      this.canvasWidth,
      this.canvasHeight
    )) as string;
    if (base64String && this.signaturePad) {
      const combinedImage = await mergeImages([
        this.signaturePad.toDataURL(),
        resizedString
      ]);
      this.signaturePad.fromDataURL(combinedImage);
      this.currentSignature = combinedImage;
    }
  }

  async onFileSelected(fileList: FileList) {
    const imageStr = (await fileToBase64(fileList[0])) as string;
    this.populateImage(imageStr);
  }

  @Emit()
  submit() {
    return this.currentSignature;
  }
}
